import { lazyLoad } from 'utils/loadable';

export const EventApplicationListPage = lazyLoad(
  () => import('./index'),
  module => module.EventApplicationListPage,
);
